var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav-bar',{attrs:{"left-arrow":_vm.left,"title":_vm.title,"fixed":"","bgColor":"#fff","leftColor":"#333","titleColor":"#333"}})
}
var staticRenderFns = []

export { render, staticRenderFns }